import { Sparkle } from "lucide-react";

const ITEMS = [
  "Student Visa · Subclass 500",
  "University Admissions",
  "Skilled Migration 189 / 190 / 491",
  "Post-Study Work · Subclass 485",
  "Employer-Sponsored Visas",
  "Family & Partner Visas",
  "Melbourne · VIC · Australia",
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="services-marquee" className="overflow-hidden border-y border-sky-100 bg-white/80 py-4">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-700/70"
          >
            {item}
            <Sparkle className="h-3 w-3 text-sky-400" />
          </span>
        ))}
      </div>
    </div>
  );
}
